<form [formGroup]="form" *ngIf="form">
    <div class="divider"></div>
    <div class="content k-d-flex k-flex-col gap-24">
        <ng-container>
            <div>
                <div class="k-d-inline-flex k-align-items-center">
                    <h4 class="k-mr-2">Site Types</h4>
                    <p *ngIf="currentAction !== ActionType.Select" (click)="toggleSelectAll(true)"
                        class="k-text-primary checkBox k-ml-2 k-pt-1">( Select All )</p>
                    <p *ngIf="currentAction === ActionType.Select" (click)="toggleSelectAll(false)"
                        class="k-text-primary checkBox k-ml-2 k-pt-1">( Deselect All )</p>
                </div>
                <div class="k-mt-2" *ngFor="let item of constants?.siteTypes; let i = index">
                    <input type="checkbox" size="medium" kendoCheckBox [formControlName]="item.control"
                        [id]="'checkbox-' + i" />
                    <kendo-label class="k-checkbox-label" [for]="'checkbox-' + i" [text]="item.label"></kendo-label>
                </div>
            </div>
            <div class="divider"></div>
            <kendo-floatinglabel text="Preschool Type" class="functional-grade-level__form-label">
                <kendo-dropdownlist [data]="referenceData?.preSchoolType" size="large" rounded="large"
                    textField="description" valueField="description" formControlName="preSchoolType">
                </kendo-dropdownlist>
            </kendo-floatinglabel>

            <div class="k-d-flex district-borough">
                <kendo-floatinglabel text="District" class="functional-grade-level__form-label district-borough-width">
                    <kendo-dropdownlist [data]="referenceData?.district" size="large" rounded="large"
                        textField="description" valueField="description" formControlName="district">
                    </kendo-dropdownlist>
                </kendo-floatinglabel>
                <kendo-floatinglabel text="Borough" class="functional-grade-level__form-label district-borough-width">
                    <kendo-dropdownlist [data]="referenceData?.borough" size="large" rounded="large"
                        textField="description" valueField="description" formControlName="borough">
                    </kendo-dropdownlist>
                </kendo-floatinglabel>
            </div>

            <kendo-floatinglabel text="School Year" class="functional-grade-level__form-label">
                <kendo-dropdownlist [data]="schoolYears" size="large" rounded="large" textField="value"
                    valueField="value" formControlName="schoolYear">
                </kendo-dropdownlist>
            </kendo-floatinglabel>

            <h4 class="!k-m-0"> Recommended Programs</h4>
            <kendo-floatinglabel text="Program" class="k-w-full">
                <kendo-multiselect [data]="constants?.programList" formControlName="program"></kendo-multiselect>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Instruction Model" class="k-w-full">
                <kendo-multiselect [data]="specializedProgramOptions" textField="description"
                    [valuePrimitive]="true" valueField="id"
                    formControlName="specializedProgram"></kendo-multiselect>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Staffing Ratio" class="k-w-full" *ngIf="form?.value?.program?.includes('SC')">
                <kendo-multiselect [data]="referenceData?.preSchoolRatio" textField="description"
                    [valuePrimitive]="true" valueField="description" formControlName="ratio"></kendo-multiselect>
            </kendo-floatinglabel>
            <kendo-floatinglabel text="Language" class="k-w-full">
                <kendo-multiselect [data]="referenceData?.language" textField="description" [valuePrimitive]="true"
                    valueField="description" formControlName="language"></kendo-multiselect>
            </kendo-floatinglabel>
        </ng-container>

        <div class="k-d-flex k-justify-content-between k-pt-6">
            <button kendoButton themeColor="secondary" size="large" rounded="large" fillMode="outline"
                (click)="resetFilters()">
                Reset Filters
            </button>
            <button kendoButton themeColor="primary" size="large" rounded="large" fillMode="solid"
                (click)="onShowresults()">
                Show Results
            </button>
        </div>
    </div>
</form>